<template>
  <section class="bg">
    <div class="school">
      <div class="school-btns">
        <com-search-bar :list="searchData" @search="handleSearch" />
      </div>
      <div v-loading.fullscreen.lock="loading" class="school-list">
        <com-layout3
          :img-height="256"
          :list="data"
          :span="8"
          @path="handleRouteDto"
        />
        <el-pagination
          class="fun-pagination"
          :current-page="requestParams.page"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="requestParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comSearchBar from '@/components/comSearchBar'
import comLayout3 from '@/components/layout/comLayout3'
export default {
  components: { comSearchBar, comLayout3 },
  data() {
    return {
      searchData: null,
      data: null,
      total: 0,
      requestParams: {
        page: 1,
        page_size: 10,
        type: null, // 1小学2中学3幼儿园
        area_id: null,
        search: '',
        is_directly: null
      },
      loading: false,
      equipInit: mock.school.school.init
    }
  },
  computed: {
    conditionTitle() {
      return `共有${this.total}所学校`
    }
  },
  created() {
    this.loading = true
    this.initConditions()
  },
  mounted() {},
  methods: {
    async initConditions() {
      this.searchData = await this.equipInit.types()
      this.handleSearch('name', '', 0, 0)
    },
    async initData(v) {
      const obj = await this.equipInit.data(v)
      this.data = obj.data
      this.total = obj.total
      this.loading = false
    },
    handleSizeChange(val) {
      this.requestParams.page_size = val
      this.initData(this.requestParams)
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.initData(this.requestParams)
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    handleSearch(v, x, y, z) {
      var order = JSON.parse(JSON.stringify(this.searchData))
      if (v != 'search') {
        order.map((item, index) => {
          if (y == index) {
            item.default = `${y}-${z}`
          }
        })
        this.searchData = order
        if (x != 0) {
          this.requestParams[v] = x
        } else {
          this.requestParams[v] = null
        }
      }
      this.initData(this.requestParams)
    },
    handleSearch2(v) {
      this.initData(this.requestParams)
    },
    handleRouteDto(v) {
      this.$router.push({
        path: '/school/details',
        query: {
          id: v
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.fun-pagination{
  @include fun-pagination(32px,right)
}
.school {
  @include fun-layout(1);
  overflow: hidden;
  background-color: #f6f6f6;
  padding: 20px 34px 10px 34px;
  &-btns {
    padding: 24px;
    @include fun-layout(2);
  }
}
</style>
